/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Event speaker updated successfully" |
*
* @param {Speakers_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_updated_toast = /** @type {((inputs?: Speakers_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intervenant de l'evenement mis a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsredner erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Relatore dell'evento aggiornato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация о докладчике мероприятия успешно обновлена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El orador del evento se actualizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动演讲者信息已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのスピーカーが正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट स्पीकर सफलतापूर्वक अपडेट हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palestrante do evento atualizado com sucesso")
	return /** @type {LocalizedString} */ ("Event speaker updated successfully")
});